<template>
  <v-container class="cmp-distribution-statment-sidewindow dt-sidewindow">
    <div class="dt-tabs-container">
      <div class="dt-details2">
        <div class="dt-details--header">
          <div
            class="title"
            :title="
              selectedStatementDetails &&
              selectedStatementDetails.statement_import_info &&
              selectedStatementDetails.statement_import_info.account_name
            "
          >
            <span
              v-if="
                selectedStatementDetails &&
                selectedStatementDetails.statement_import_info
              "
            >
              {{
                selectedStatementDetails.statement_import_info.account_name ||
                "Account Name"
              }}
              -
              {{
                $dft.capHead(
                  selectedStatementDetails.statement_import_info.description
                ) || "Description"
              }}
              {{
                `${selectedStatementDetails.statement.statement_year}/${selectedStatementDetails.statement.statement_period_txt}` ||
                "Description"
              }}
            </span>
          </div>
        </div>
        <!-- <div class="dt-details--body">
          <div class="dt-details--col">
            <div class="ut-flex">
              <div
                v-if="selectedStatementDetails && selectedStatementDetails.statement_import_info"
              >
                {{
                  selectedStatementDetails.statement_import_info.description ||
                  "Description"
                }}
              </div>
            </div>
          </div>
        </div> -->
      </div>

      <glayout
        :tabs="importSidewindowTab"
        :options="invoice_id>0?[
          {
            text: $t('refresh'),
            value: 'refresh',
          },
          {
            text: $t('open_related_invoice'),
            value: 'open_related_invoice',
           
          },
        ]: [
          {
            text: $t('refresh'),
            value: 'refresh',
          },
          {
            text: $t('invoice_statement'),
            value: 'invoice_statement',
          },
        ] "
        @optionClicked="onImportResultButtonClick"
      >
        <!-- :loading="selectedStatementDetails && selectedStatementDetails.loading" -->
        <gtab id="import" v-if="invoice_id == ''">
          <!-- @click="onRoyaltyReleaseUpdate" -->
          <!-- <template #header>
          
            <grow>
              <gcol>
                <div class="ut-flex">
                  <button
                    style="margin-left: 0px"
                    class="dt-button v5 s8"
                    v-for="item in tabOptions"
                    :key="item.value"
                    @click="onTabOptionClicked(item.value)"
                  >
                    {{ item.text }}
                  </button>
                </div>
              </gcol>
            </grow>
          </template> -->
          <grow>
            <gcol>
              <gbox
                :title="$dft.capHead($t('upload'))"
                v-if="
                  selectedStatementDetails &&
                  selectedStatementDetails.selected_columns &&
                  selectedStatementDetails.stmt
                "
                :h="
                  boxHeightNamed({
                    rowCount:
                      (selectedStatementDetails &&
                        selectedStatementDetails.file &&
                        selectedStatementDetails.file.imported_data &&
                        selectedStatementDetails.file.imported_data.length) ||
                      0,
                    offset: NTOffsets.WithHeaderDBoxBottom,
                    min: 1,
                  })
                "
                :loading="
                  selectedStatementDetails &&
                  selectedStatementDetails.statementData_loading
                "
              >
                <ImportConfgTable
                  @tab_click="onTabOptionClicked"
                  @upload_click="onUploadClick"
                  @close="onClose"
                  :selectedStatementDetails="selectedStatementDetails"
                />
              </gbox>
            </gcol>
          </grow>
          <grow>
            <gcol>
              <gbox
                :title="$dft.capHead($t('setup'))"
                v-if="
                  showBoxFlag([
                    'digital',
                    'physical',
                    'thirdparty',
                    'performance',
                  ])
                "
                :loading="
                  selectedStatementDetails &&
                  selectedStatementDetails.statementData_loading
                "
              >
                <ImportSetup
                  @changed="onImportSetupChange"
                  :selectedStatementDetails="selectedStatementDetails"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox
                :title="`${$dft.capHead($t('return'))} ${$dft.capHead(
                  $t('setup')
                )}`"
                v-if="
                  showBoxFlag([
                    'digital',
                    'physical',
                    'thirdparty',
                    'performance',
                  ])
                "
                :loading="
                  selectedStatementDetails &&
                  selectedStatementDetails.statementData_loading
                "
              >
                <ReturnSetup
                  @changed="onImportSetupChange"
                  @tab_click="onTabOptionClicked"
                  :selectedStatementDetails="selectedStatementDetails"
                />
              </gbox>
            </gcol>
          </grow>
          <grow>
            <gcol></gcol>
            <gcol>
              <ButtonList
                style="justify-content: end"
                @menuClick="onTabOptionClicked"
                :buttonList="tabOptions"
              />
            </gcol>
          </grow>
        </gtab>
        <gtab id="import_matching" v-if="invoice_id == ''">
          <grow>
            <gcol>
              <gbox
                :title="$dft.capHead($t('import_errors'))"
                v-if="
                  showBoxFlag([
                    'digital',
                    'physical',
                    'thirdparty',
                    'performance',
                  ])
                "
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedStatementDetails &&
                      selectedStatementDetails.statement_lines &&
                      selectedStatementDetails.statement_lines.length,
                    offset: NTOffsets.WithHeaderDBoxBottom,
                    max: 10,
                    min: 1,
                  })
                "
                :loading="
                  selectedStatementDetails &&
                  selectedStatementDetails.statementImportErrorData_loading
                "
              >
                <ImportMatch
                  @delete="onDeleteImportMatch"
                  @change="onImportMatchChange"
                  @scroll="onImportMatchScroll"
                  :selectedStatementDetails="selectedStatementDetails"
                />
              </gbox>
              <template v-if="showBoxFlag(['costs', 'income'])">
                <gbox
                  :title="$dft.capHead($t('match'))"
                  v-if="
                    selectedStatementDetails &&
                    selectedStatementDetails.costgroup_lines
                  "
                  :h="
                    boxHeightNamed({
                      rowCount:
                        selectedStatementDetails &&
                        selectedStatementDetails.costgroup_lines &&
                        selectedStatementDetails.costgroup_lines.length,
                      offset: NTOffsets.WithHeaderDBoxBottom,
                      max: 10,
                      min: 1,
                    })
                  "
                  :loading="
                    selectedStatementDetails &&
                    selectedStatementDetails.statementImportErrorData_loading
                  "
                >
                  <CostImportMatch
                    :selectedStatementDetails="selectedStatementDetails"
                    @update="onUpdateCostGroup"
                    @processGroup="onProcessGroup"
                  />
                </gbox>
                <gbox
                  :title="$dft.capHead($t('import_errors'))"
                  v-else
                  :h="
                    boxHeightNamed({
                      rowCount:
                        selectedStatementDetails &&
                        selectedStatementDetails.statement_lines &&
                        selectedStatementDetails.statement_lines.length,
                      offset: NTOffsets.WithHeaderDBoxBottom,
                      max: 10,
                      min: 1,
                    })
                  "
                  :loading="
                    selectedStatementDetails &&
                    selectedStatementDetails.statementImportErrorData_loading
                  "
                >
                  <ImportMatch
                    @delete="onDeleteImportMatch"
                    @change="onImportMatchChange"
                    @scroll="onImportMatchScroll"
                    :selectedStatementDetails="selectedStatementDetails"
                  />
                </gbox>
              </template>
            </gcol>
          </grow>
        </gtab>
        <gtab id="import_result" :title="$t('tab_title_import_result')">
          <!-- <template #header>
            <grow>
              <gcol>
                <div class="ut-flex" style="align-items: right">
                  <ImportResultButton
                    :selectedStatementDetails="selectedStatementDetails"
                    :buttonList="buttonArray"
                    @menuClick="onImportResultButtonClick"
                  />
                  <ImportResultTotal
                    style="width: 380px; padding-left: 15px"
                    :selectedStatementDetails="selectedStatementDetails"
                    :totalSummary="totalSummary"
                  />
                </div>
              </gcol>
            </grow>
          </template> -->
          <grow>
            <gcol>
              <gbox
                v-if="showBoxFlag(['physical'])"
                :title="$dft.capHead($t('catalogs'))"
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedStatementDetails &&
                      selectedStatementDetails.catalogs &&
                      selectedStatementDetails.catalogs.length,
                    offset: NTOffsets.WithHeader,
                    max: 10,
                    min: 1,
                  })
                "
                :loading="
                  selectedStatementDetails &&
                  selectedStatementDetails.physicalStmtImportResultData_loading
                "
              >
                <ImportResultCatalog
                  @menuClick="onImportResultButtonClick"
                  :selectedStatementDetails="selectedStatementDetails"
                />
              </gbox>
              <gbox
                v-if="showBoxFlag(['digital'])"
                :title="$dft.capHead($t('shops'))"
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedStatementDetails &&
                      selectedStatementDetails.shops &&
                      selectedStatementDetails.shops.length,
                    offset: NTOffsets.WithHeader,
                    max: 10,
                    min: 1,
                  })
                "
                :loading="
                  selectedStatementDetails &&
                  selectedStatementDetails.digitalStmtImportResultData_loading
                "
              >
                <ImportResultShop
                  @menuClick="onImportResultButtonClick"
                  :selectedStatementDetails="selectedStatementDetails"
                />
              </gbox>
              <gbox
                v-if="showBoxFlag(['costs', 'income'])"
                :title="$dft.capHead($t('releases'))"
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedStatementDetails &&
                      selectedStatementDetails.releases &&
                      selectedStatementDetails.releases.length,
                    offset: NTOffsets.WithHeaderDBoxBottom,
                    max: 10,
                    min: 1,
                  })
                "
                :loading="
                  selectedStatementDetails &&
                  selectedStatementDetails.costIncomeStmtImportResultData_loading
                "
              >
                <ImportResultCostRelease
                  @menuClick="onImportResultButtonClick"
                  :selectedStatementDetails="selectedStatementDetails"
                />
              </gbox>
              <gbox
                v-if="showBoxFlag(['thirdparty', 'performance'])"
                :title="$dft.capHead($t('item'))"
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedStatementDetails &&
                      selectedStatementDetails.items &&
                      selectedStatementDetails.items.length,
                    offset: NTOffsets.WithHeaderDBoxBottom - 48,
                    max: 10,
                    min: 1,
                  })
                "
                :loading="
                  selectedStatementDetails &&
                  selectedStatementDetails.thirdpartyPerformanceStmtImportResultData_loading
                "
              >
                <ImportResultItem
                  :selectedStatementDetails="selectedStatementDetails"
                />
              </gbox>
            </gcol>
          </grow>
          <grow>
            <gcol>
              <gbox
                v-if="showBoxFlag(['physical', 'digital'])"
                :title="$dft.capHead($t('releases'))"
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedStatementDetails &&
                      selectedStatementDetails.releases &&
                      selectedStatementDetails.releases.length,
                    offset: NTOffsets.WithHeader,
                    max: 10,
                    min: 1,
                  })
                "
                :loading="
                  selectedStatementDetails &&
                  (selectedStatementDetails.digitalStmtImportResultData_loading ||
                    selectedStatementDetails.physicalStmtImportResultData_loading)
                "
              >
                <ImportResultRelease
                  :selectedStatementDetails="selectedStatementDetails"
                />
              </gbox>
              <gbox
                v-if="showBoxFlag(['costs', 'income'])"
                :title="$dft.capHead($t('label'))"
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedStatementDetails &&
                      selectedStatementDetails.labels &&
                      selectedStatementDetails.labels.length,
                    offset: NTOffsets.WithHeader,
                    max: 10,
                    min: 1,
                  })
                "
                :loading="
                  selectedStatementDetails &&
                  selectedStatementDetails.costIncomeStmtImportResultData_loading
                "
              >
                <ImportResultLabel
                  :selectedStatementDetails="selectedStatementDetails"
                />
              </gbox>

              <!-- <gbox 
                v-if="showBoxFlag(['physical','digital','thirdparty','performance','costs','income'])"
                :title="$dft.capHead($t('total'))" 
                :h="boxHeightNamed({
                    rowCount:
                      totalSummary &&
                      totalSummary.length,
                    offset: NTOffsets.default,
                    rowHeight:28,
                    max: 10,
                    min: 1,
                  })"
              >
                <ImportResultTotal 
                  :selectedStatementDetails="selectedStatementDetails"
                  :totalSummary="totalSummary" 
                />
              </gbox> -->
            </gcol>
          </grow>
          <grow>
            <gcol>
              <gbox
                v-if="showBoxFlag(['physical', 'digital'])"
                :title="$dft.capHead($t('countries'))"
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedStatementDetails &&
                      selectedStatementDetails.countries &&
                      selectedStatementDetails.countries.length,
                    offset: NTOffsets.WithHeader,
                    max: 10,
                    min: 1,
                  })
                "
                :loading="
                  selectedStatementDetails &&
                  (selectedStatementDetails.digitalStmtImportResultData_loading ||
                    selectedStatementDetails.physicalStmtImportResultData_loading)
                "
              >
                <ImportResultCountry
                  :selectedStatementDetails="selectedStatementDetails"
                />
              </gbox>
              <gbox
                v-if="showBoxFlag(['costs', 'income'])"
                :title="$dft.capHead($t('groups'))"
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedStatementDetails &&
                      selectedStatementDetails.groups &&
                      selectedStatementDetails.groups.length,
                    offset: NTOffsets.WithHeader,
                    max: 10,
                    min: 1,
                  })
                "
                :loading="
                  selectedStatementDetails &&
                  selectedStatementDetails.costIncomeStmtImportResultData_loading
                "
              >
                <ImportResultGroup
                  :selectedStatementDetails="selectedStatementDetails"
                />
              </gbox>
            </gcol>
            <gcol>
              <ImportResultTotal
                style="width: 380px; padding-left: 15px; padding-top: 30px"
                :selectedStatementDetails="selectedStatementDetails"
                :totalSummary="totalSummary"
              />
            </gcol>
          </grow>
        </gtab>
        <gtab id="sales_details" v-if="invoice_id == ''">
          <grow>
            <gcol>
              <gbox
                v-if="
                  showBoxFlag([
                    'digital',
                    'physical',
                    'thirdparty',
                    'performance',
                  ])
                "
                :title="$dft.capHead($t('sales_details'))"
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedStatementDetails &&
                      selectedStatementDetails.sales_details &&
                      selectedStatementDetails.sales_details.length,
                    offset: NTOffsets.WithHeader,
                    rowHeight:
                      selectedStatementDetails &&
                      selectedStatementDetails.sales_details &&
                      selectedStatementDetails.sales_details.length > 0
                        ? 62
                        : 32,
                    max: 10,
                    min: 1,
                  })
                "
                :loading="
                  selectedStatementDetails &&
                  selectedStatementDetails.statementImportResultData_loading
                "
              >
                <SalesDetails
                  @delete="onDeleteSalesDetails"
                  :selectedStatementDetails="selectedStatementDetails"
                />
              </gbox>
              <gbox
                v-if="showBoxFlag(['costs', 'income'])"
                :title="`${$dft.capHead($t('detail'))}s`"
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedStatementDetails &&
                      selectedStatementDetails.cost_income_details &&
                      selectedStatementDetails.cost_income_details.length,
                    offset: NTOffsets.WithHeader,
                    max: 10,
                    min: 1,
                  })
                "
                :loading="
                  selectedStatementDetails &&
                  selectedStatementDetails.statementIncomeData_loading
                "
              >
                <CostIncomeDetails
                  @delete="onDeleteSalesDetails"
                  @update="onUpdateCostIncomedetails"
                  :selectedStatementDetails="selectedStatementDetails"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab
          id="cost_details"
          v-if="
            currentChannel != 'digital' &&
            currentChannel != 'costs' &&
            currentChannel != 'income' &&
            currentChannel != 'performance' &&
            currentChannel != 'thirdparty' &&
            invoice_id == ''
          "
          :title="$t('cost')"
        >
          <grow>
            <gcol>
              <gbox
                v-if="showBoxFlag(['physical'])"
                :title="`${$dft.capHead($t('cost'))}s`"
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedStatementDetails &&
                      selectedStatementDetails.cost_details &&
                      selectedStatementDetails.cost_details.length,
                    offset: NTOffsets.WithHeader,
                    max: 10,
                    min: 1,
                  })
                "
                :loading="
                  selectedStatementDetails &&
                  selectedStatementDetails.statementCostsData_loading
                "
              >
                <CostDetails
                  @delete="onDeleteSalesDetails"
                  @update="onUpdateCostIncomedetails"
                  :selectedStatementDetails="selectedStatementDetails"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="summary">
          <!-- <template #header>
            <grow>
              <gcol>
                <v-menu
                :close-on-content-click="false"
                open-on-hover
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <span slot="activator">
                  <button
                    style="margin-left: 0px"
                    class="dt-button v5 s8"
                  >
                    {{ $t("sales_import_info") }}
                  </button>
                
                </span>
                <div style="background-color: white">
                  <SalesImportInfo 
                      style="cursor:copy"
                    
                    :selectedStatementDetails="selectedStatementDetails" 
                    @changed="onUpdated"
                  />
                </div>
              </v-menu>
                <div style="margin-top:5px">
                 
                </div>
              </gcol>
            </grow>
          </template> -->
          <grow>
            <gcol>
              <gbox
                :title="$dft.capHead($t('setup'))"
                :loading="
                  selectedStatementDetails &&
                  selectedStatementDetails.statementSummaryData_loading
                "
              >
                <StatementSetup
                  :selectedStatementDetails="selectedStatementDetails"
                  @changed="onUpdated"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox
                :title="$t('contact')"
                :loading="
                  selectedStatementDetails &&
                  selectedStatementDetails.statementSummaryData_loading
                "
              >
                <InvoiceContact
                  :invoiceContact="selectedStatementDetails.contact"
                  :contactConfig="{
                    external_id:
                      selectedStatementDetails.statement.statement_id,
                    external_table: 'l_statements',
                    key: 'statement_id',
                    config_type: 'l_statements',
                  }"
                />
              </gbox>
            </gcol>
          </grow>
          <grow>
            <gcol>
              <gbox
                :title="$t('statement_summary')"
                bc="#F7FFF2"
                :h="
                  boxHeightNamed({
                    rowCount: statementSummary && statementSummary.length,
                    offset: NTOffsets.WithHeaderDBoxBottom,
                    rowHeight: 32,
                    min: 1,
                  })
                "
                :loading="
                  selectedStatementDetails &&
                  selectedStatementDetails.statementSummaryData_loading
                "
              >
                <StatementSummary
                  @tabChange="onTabOptionClicked"
                  :selectedStatementDetails="selectedStatementDetails"
                  :statementSummary="statementSummary"
                  @changed="onUpdated"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedStatementDetails &&
                      selectedStatementDetails.files &&
                      selectedStatementDetails.files.length,
                    offset: NTOffsets.WithDBoxBottom,
                    min: 0,
                  })
                "
                :title="$t('related_document_1')"
                :loading="
                  selectedStatementDetails &&
                  selectedStatementDetails.statementSummaryData_loading
                "
              >
                <DBoxFiles
                  v-if="selectedStatementDetails"
                  :files="selectedStatementDetails.files"
                  :externalId="`${this.statement_id}`"
                  :externalTable="'statement'"
                />
              </gbox>

              <gbox
                :title="$t('notes')"
                bc="var(--bc-note)"
                :loading="
                  selectedStatementDetails &&
                  selectedStatementDetails.statementSummaryData_loading
                "
              >
                <DBoxTextarea
                  v-if="selectedStatementDetails"
                  :id="'notes'"
                  :value="selectedStatementDetails.statement.notes"
                  @blur="
                    (e) => onUpdated({ name: 'notes', value: e.target.value })
                  "
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
      </glayout>

      <input
        type="file"
        id="filepicker"
        @input="onFilePickerChange"
        style="visibility: hidden; display: none"
        accept=".xls, .xlsx, .csv, .txt, .tab, .tsv"
        name="filepicker"
      />

      <ModalContainer :modalKey="'licenceIncomeForm'" :width="'small'">
        <LicenceIncomeForm
          :selectedStatementDetails="selectedStatementDetails"
          @cancelled="onDialogCancelled"
          @added="onIncomeAdded"
          @edited="onIncomeEdited"
        />
      </ModalContainer>

      <ModalContainer :modalKey="'labelCopy'" :width="'small'">
        <LabelCopy @cancelled="onDialogCancelled" />
      </ModalContainer>

      <ModalContainer :modalKey="'removeMinimalIncome'" :width="'small'">
        <RemoveMinimalIncomeModal
          @change="onImportMatchChange"
          @cancelled="onDialogCancelled"
        />
      </ModalContainer>

      <ModalContainer
        @cancelled="onDialogCancelled"
        :modalKey="'loadPreset'"
        :width="'medium'"
      >
        <LoadPresetModal
          @load_preset="onLoadPreset"
          @cancelled="onDialogCancelled"
        />
      </ModalContainer>

      <ModalContainer
        @cancelled="onDialogCancelled"
        :modalKey="'splitStatementModal'"
        :width="'small'"
      >
        <SplitStatementIncomeModal
          :selectedStatementDetails="selectedStatementDetails"
          @change="onImportMatchChange"
          @cancelled="onDialogCancelled"
        />
      </ModalContainer>

      <ModalContainer
        @cancelled="onDialogCancelled"
        :modalKey="'progressBarModal'"
        :width="'small'"
      >
        <ProgressBarModal
          :fileUploadingFlag="fileUploadingFlag"
          :fileUploaderDuration="fileUploaderDuration"
          :fileUploaderProgress="fileUploaderProgress"
          @cancelled="onDialogCancelled"
        />
      </ModalContainer>

      <ModalContainer
        @cancelled="onDialogCancelled"
        :modalKey="'salesImportInfoModal'"
        :width="'small'"
      >
        <SalesImportInfoModal
          style="cursor: copy; background-color: white"
          :selectedStatementDetails="selectedStatementDetails"
          @cancelled="onDialogCancelled"
        />
      </ModalContainer>
    </div>
  </v-container>
</template>

<script>
import { DistributionStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { mapGetterObject, mapActionObject } from "../../../../store/global";

import {
  checkTabListPermission,
  checkTabGridItemPermission,
} from "../../../../router/guard";

//CMP
import DBoxFiles from "@/dt-plugins/dbox-files/dbox-files";
import DBoxTextarea from "@/dt-plugins/dbox-textarea/dbox-textarea";
import StatementSetup from "./statement-setup";
import StatementSummary from "./statment-summary.vue";
import SalesImportInfo from "./sales-import-info.vue";
import SalesImportInfoModal from "./sales-import-info-modal.vue";
import InvoiceContact from "@/dt-plugins/dbox-invoice-contact/dbox-invoice-contact.vue";
import ImportMatch from "./import-match.vue";
import ImportSetup from "./import-setup.vue";

import ReturnSetup from "./import-return-setup.vue";

import ImportResultRelease from "./import-result-release.vue";
import ImportResultCountry from "./import-result-country.vue";
import ImportResultCatalog from "./import-result-catalog.vue";
import SalesDetails from "./sales-details.vue";

import ImportResultShop from "./import-result-shop.vue";

import ImportResultLabel from "./import-result-label.vue";
import ImportResultGroup from "./import-result-group.vue";

import ImportResultCostRelease from "./import-result-cost-release.vue";

import ImportResultItem from "./import-result-item.vue";

import CostIncomeDetails from "./cost-income-details.vue";

import CostDetails from "./cost-details.vue";

import ImportConfgTable from "./import-config-table.vue";

import CostImportMatch from "./cost-import-match.vue";

import ImportResultTotal from "./import-result-total.vue";

import ImportResultButton from "./import-result-header-button.vue";

import ButtonList from "@dtplugins/dt-button-list/button-list.vue";

//modal
import RemoveMinimalIncomeModal from "./remove-minimal-income-modal.vue";
import LoadPresetModal from "./load-preset-modal.vue";
import SplitStatementIncomeModal from "./split-statement-income-modal.vue";

import { distributionStatementsGetters } from "../../store/statement/getters";
import { distributionStatementsActions } from "../../store/statement/actions";
import {
  createModalMixin,
  closeModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";
import ModalContainer from "@dtplugins/modal/modal-container";
import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";
import { NotificationService } from "../../../../dt-plugins/notification/notification.service";
import { DistributionStatementService } from "../../services/statement.service";
import { getNoteRow, wait } from "../../../../utility";
import FileDownload from "js-file-download";

import ProgressBarModal from "@plugins/progress-bar/progress-bar-modal";
import { statementServices } from "../../../royalty/services/statements/statements.service";
import {
  costListLDTRoutes,
  invoiceListLDTRoutes,
} from "../../../accounting/router/routes";
import { distributionAccountListLDTRoutes } from "../../router/routes";
import { handleCloseTab } from "../../../../dt-plugins/sidewindow/nav-tab";
import {
  ConfirmationService,
  createConfirmResult,
} from "../../../../dt-plugins/confirmation/confirmation.service";
import { okMessage } from "../../../../dt-plugins/confirmation/confirmation-common";
export const moduleRoute = "distribution";
export const submenuRoute = "statement_list";

export default {
  components: {
    ModalContainer,

    DBoxTextarea,
    DBoxFiles,
    StatementSetup,
    InvoiceContact,
    ImportSetup,
    ReturnSetup,
    ImportMatch,
    ImportResultRelease,
    ImportResultCountry,
    StatementSummary,
    SalesImportInfo,
    SalesImportInfoModal,
    SalesDetails,
    ImportResultCatalog,
    ImportResultShop,
    ImportResultLabel,
    ImportResultGroup,
    ImportResultCostRelease,
    ImportResultItem,
    CostIncomeDetails,
    CostDetails,
    ButtonList,
    ImportConfgTable,
    CostImportMatch,
    RemoveMinimalIncomeModal,
    LoadPresetModal,
    SplitStatementIncomeModal,
    ImportResultTotal,
    ImportResultButton,
    ProgressBarModal,
  },
  data() {
    return {
      fileUploadingFlag: false,
      fileUploaderDuration: 2400,
      fileUploaderProgress: 0,
    };
  },
  mixins: [
    createModalMixin("loadPreset"),
    createModalMixin("licenceIncomeForm"),
    createModalMixin("batchLicence"),
    createModalMixin("labelCopy"),
    createModalMixin("removeMinimalIncome"),
    createModalMixin("splitStatementModal"),
    createModalMixin("progressBarModal"),
    createModalMixin("salesImportInfoModal"),
    createDTGridHost(),
  ],
  computed: {
    ...mapGetterObject(storeNS, distributionStatementsGetters),

    invoice_id: function () {
      return this.selectedStatementDetails?.statement?.invoice_id || "";
    },
    currentChannel: function () {
      return this.selectedStatementDetails?.statement?.digital_physical || "";
    },
    tabOptions: function () {
      const options =
        this.currentChannel == "costs"
          ? [
              {
                text: this.$t("btn_save_conf"),
                value: "btn_save_conf",
              },
            ]
          : [
              {
                text: this.$t("load_preset_btn"),
                value: "load_preset_btn",
              },
              {
                text: this.$t("btn_save_conf"),
                value: "btn_save_conf",
              },
            ];
      if (this.$store.getters.account.user.user_name == "details_helper") {
        return [
          { text: this.$t("new_preset_btn"), value: "new_preset_btn" },
          ...options,
        ];
      }

      return this.invoice_id == ""
        ? options
        : options.filter((x) => x.value == "new_preset_btn");
    },

    importSidewindowTab: function () {
      let tabList = [
        {
          route: "import",
          value: this.$t("import"),
          // vgi_id: "import",
        },
        {
          route: "import_matching",
          value: this.$t("tab_title_import_matching"),
          //vgi_id: "import_matching",
        },
        {
          route: "import_result",
          value: this.$t("tab_title_import_result"),
          // vgi_id: "import_result",
        },
        {
          route: "sales_details",
          value: "details",
          // vgi_id: "sales_details",
        },
        {
          route: "cost_details",
          value: this.$t("cost"),
          // vgi_id: "sales_details",
        },

        {
          route: "summary",
          value: this.$t("tab_title_summary"),
          // vgi_id: "summary",
        },
      ];

      if (this.invoice_id != "") {
        tabList = tabList.filter(
          (x) => x.route == "summary" || x.route == "import_result"
        );
      }
      if (this.currentChannel == "digital") {
        tabList = tabList.filter((x) => x.route != "cost_details");
      }
      if (
        this.currentChannel == "costs" ||
        this.currentChannel == "income" ||
        this.currentChannel == "thirdparty" ||
        this.currentChannel == "performance"
      ) {
        tabList = tabList.filter((x) => x.route != "cost_details");
      }

      return checkTabListPermission(moduleRoute, submenuRoute, tabList);
    },

    statement_id: function () {
      return this.$route.params.statement_id;
    },

    selectedStatementDetails: function () {
      const distributionStatementDetails =
        (this.distributionStatementDetails || {})[this.statement_id] || {};
      let statement = distributionStatementDetails.statement || {};
      const contact = distributionStatementDetails.contact || {};
      const column_names = distributionStatementDetails.column_names || [];
      const selected_columns =
        distributionStatementDetails.selected_columns || [];
      const all_lines_assigned =
        distributionStatementDetails.all_lines_assigned;
      const json_data = statement.json_data
        ? JSON.parse(statement.json_data)
        : {};
      statement = {
        ...statement,
        ...json_data,
      };
      console.log("statement", statement);
      // console.log("this.licencesDetails:::", distributionStatementDetails);
      // const licence_account = licencesDetails.licence_account || {};
      // const invoice_contact = licencesDetails.invoice_contact || {};

      // If statement_lines length is greater then 0 then route to import Matching
      // if (
      //   !distributionStatementDetails.loading &&
      //   distributionStatementDetails.statement_lines
      // ) {
      //   if (distributionStatementDetails.statement_lines.length > 0) {
      //     setTimeout(() => {
      //       // console.log({'statement-sidewindow.vue:996 statement_lines' : distributionStatementDetails});
      //       this.$router.push({
      //         ...this.$route,
      //         params: {
      //           ...this.$route.params,
      //           tab: "import_matching",
      //         },
      //       });
      //     }, 1000);
      //   } else {
      //     setTimeout(() => {
      //       // console.log({'statement-sidewindow.vue:1005 statement_lines' : distributionStatementDetails});
      //       this.$router.push({
      //         ...this.$route,
      //         params: {
      //           ...this.$route.params,
      //           tab: "import_result",
      //         },
      //       });
      //     }, 1000);
      //   }
      // }

      console.log({
        selStDet: {
        ...distributionStatementDetails,
        statement,
        contact,
        column_names,
        selected_columns,
        all_lines_assigned,
        }
      });

      return {
        ...distributionStatementDetails,
        statement,
        contact,
        column_names,
        selected_columns,
        all_lines_assigned,
        //  licence_account,
        //  invoice_contact
      };
    },
    currentChannel: function () {
      //statement this.selectedStatementDetails?.stmt?.digital_physical;
      return this.selectedStatementDetails?.statement?.digital_physical;
    },

    buttonArray: function () {
      let buttonList = [
        {
          text: this.$t("invoice_statement"),
          value: "invoice_statement",
        },
        {
          text: this.$t("refresh"),
          value: "refresh",
        },
      ];

      if (this.currentChannel == "digital") {
        buttonList = [
          ...buttonList,
          // {
          //   text: this.$t('ppu_fix_amount_btn'),
          //   value: 'ppu_fix_amount_btn',
          // },
        ];
      } else if (this.currentChannel == "physical") {
        buttonList = [
          ...buttonList,
          {
            text: this.$t("price_export"),
            value: "price_export",
          },
        ];
      }

      if (this.invoice_id == "") {
        return [...buttonList];
      } else {
        return [
          {
            text: this.$t("open_related_invoice"),
            value: "open_related_invoice",
          },
        ];
      }
    },

    totalSummary: function () {
      //   console.log("STRING",this.selectedStatementDetails?.statement);
      const statementObject = this.selectedStatementDetails?.statement || {};

      // console.log("PARSED JSON", statementObject);

      let summaryArray = [];

      if (statementObject != {}) {
        summaryArray = [
          {
            types: "promos",
            units: statementObject.promo_qty,
            amounts: "",
          },
          {
            types: "foc",
            units: statementObject.foc_qty,
            amounts: "",
          },
          {
            types: "sales",
            units: statementObject.sales_qty,
            amounts: statementObject.sales_amount,
          },
          {
            types: "returns",
            units: statementObject.returns_qty,
            amounts: statementObject.return_amount,
          },
          {
            types: "total",
            units: statementObject.sales_qty - statementObject.returns_qty,
            amounts: statementObject.statement_amount,
          },
        ];
      }
      if (this.currentChannel == "digital") {
        return [...summaryArray].filter((x) => x.types != "foc");
      } else if (
        this.currentChannel == "thirdparty" ||
        this.currentChannel == "performance"
      ) {
        return [...summaryArray].filter((x) => x.types != "foc");
      } else if (
        this.currentChannel == "costs" ||
        this.currentChannel == "income"
      ) {
        return [
          {
            types: "total",
            units: "",
            amounts: statementObject.statement_amount,
          },
        ];
      }

      return [...summaryArray];
    },
    statementSummary: function () {
      if (!this.selectedStatementDetails?.statement?.json_data) {
        return;
      }
      // console.log("STRING", this.selectedStatementDetails?.statement);
      const statementObject = this.selectedStatementDetails?.statement || {};
      const statementJSonObject =
        JSON.parse(this.selectedStatementDetails?.statement?.json_data) || {};
      // console.log("PARSED JSON", statementObject);

      let summaryArray = [];

      if (statementObject != {}) {
        summaryArray = [
          {
            types: "sales",
            units: statementObject.sales_qty,
            amounts: statementObject.sales_amount,
          },
          {
            types: "returns",
            units: statementObject.returns_qty,
            amounts: statementObject.return_amount,
          },
          {
            types: "promos",
            units: statementObject.promo_qty,
            amounts: "",
          },
          {
            types: "foc",
            units: statementObject.foc_qty,
            amounts: "",
          },
          // {
          //   types:'',
          //   units:'',
          //   amounts:'',
          // },
          {
            types: "return_handling",
            units: "",
            amounts: statementObject.return_handling_amount,
          },
          {
            types: "cost",
            units: "",
            amounts: statementObject.cost_amount,
          },
          // {
          //   types:'',
          //   units:'',
          //   amounts:'',

          // },
          {
            types: "Calculate Total",
            units: "",
            amounts: statementObject.sales_amount,
          },
          {
            types: "Rounding Difference",
            units: "",
            amounts: "- - -",
          },
          // {
          //   types:'',
          //   units:'',
          //   amounts:'',
          // },
          {
            types: "amount_of_statement",
            units: "",
            amounts: `${statementObject.statement_amount}`,
          },
        ];
      }

      //return summaryArray

      if (this.currentChannel == "digital") {
        //console.log("digital",summaryArray.filter(x=>x.types!='foc' && x.types!='cost'))
        return summaryArray.filter(
          (x) =>
            x.types != "foc" &&
            x.types != "cost" &&
            x.types != "return_handling"
        );
      } else if (this.currentChannel == "physical") {
        return summaryArray;
      } else if (
        this.currentChannel == "costs" ||
        this.currentChannel == "income"
      ) {
        //console.log("costs",summaryArray.filter(x=>x.types!='sales'&& x.types!='returns' && x.types!='promos' && x.types!='foc' && x.types!='return_handling'))
        return summaryArray.filter(
          (x) =>
            x.types != "sales" &&
            x.types != "returns" &&
            x.types != "promos" &&
            x.types != "foc" &&
            x.types != "return_handling"
        );
      } else if (this.currentChannel == "performance") {
        return [
          {
            types: "total",
            units: `${
              parseInt(statementObject.sales_qty) +
              parseInt(statementObject.returns_qty)
            }`,
            amounts: `${
              parseInt(statementObject.sales_amount) +
              parseInt(statementObject.return_amount)
            }`,
          },
          ...summaryArray.filter(
            (x) =>
              x.types != "sales" &&
              x.types != "returns" &&
              x.types != "cost" &&
              x.types != "promos" &&
              x.types != "foc" &&
              x.types != "return_handling"
          ),
        ];
      } else if (this.currentChannel == "thirdparty") {
        return summaryArray.filter(
          (x) => x.types != "cost" && x.types != "return_handling"
        );
      }
    },

    //MARK: Computed
  },
  methods: {
    ...mapActionObject(storeNS, distributionStatementsActions),

    showBoxFlag: function (channelName = []) {
      let flag = false;
      channelName.forEach((e) => {
        if (this.currentChannel == e) {
          flag = true;
        }
      });

      //console.log(flag,"::::::::::::",channelName,this.setupParameter['digital_physical'])

      return flag;
    },

    async onTabOptionClicked(value) {
      console.log("value", value);
      switch (value) {
        case "new_preset_btn": {
          this.$router.push({
            ...this.$route,
            query: {
              modal: "add_new_preset",
              digital_physical:
                this.selectedStatementDetails?.statement?.digital_physical ||
                "",
              //statement_id: this.statement_id,
            },
          });
          break;
        }
        case "load_preset_btn": {
          this.$router.push({
            ...this.$route,
            query: {
              modal: "load_preset",
              channel:
                this.selectedStatementDetails?.statement?.digital_physical ||
                "",
              statement_id: this.statement_id,
            },
          });
          break;
        }
        case "btn_save_conf": {
          NotificationService.showNotification({
            text: this.$t("btn_save_conf_confirmation"),
            timeout: 3000,
            // color: "info"
          });
          const returns_have_leading_minus =
            this.selectedStatementDetails?.statement
              ?.returns_have_leading_minus &&
            this.selectedStatementDetails?.statement
              ?.returns_have_leading_minus != ""
              ? this.selectedStatementDetails?.statement
                  ?.returns_have_leading_minus
              : 0;

          console.log(
            "::::::::::::::returns_have_leading_minus",
            returns_have_leading_minus
          );

          await DistributionStatementService.saveStatementConf({
            ...this.selectedStatementDetails.statement,
            column_names: this.selectedStatementDetails.selected_columns,
            returns_have_leading_minus: returns_have_leading_minus,
          });
          //await statementServices.saveStatementConf({...this.selectedStatementDetails.statement ,column_names:this.selectedStatementDetails.selected_columns})
          //this[ActionTypes.DistributionStatementsDetails.FETCH.SINGLE]({flag: true ,statement: this.selectedStatementDetails.statement ,reload:true});
          break;
        }
        case "sales_import_info": {
          this.$router.push({
            ...this.$route,
            query: {
              modal: "sales_import_info_modal",
            },
          });
          break;
        }
        case "price_export": {
          this.onPriceExportClick();
          break;
        }
      }
      console.log(
        "selectedStatementDetails",
        this.selectedStatementDetails?.statement?.digital_physical
      );
    },

    onUpdated: function (payload) {
      this[ActionTypes.DistributionStatementsDetails.UPDATE.SINGLE]({
        ...payload,
        item: this.selectedStatementDetails,
      });
    },

    onRelatedContactDelete: function (contact) {
      this[ActionTypes.LicenceAccountRelatedContacts.DELETE.SINGLE]({
        contact,
        licence_account: this.selectedStatementDetails.licence_account,
      });
    },
    onRelatedContactChange: function ({ name, value, item }) {
      this[ActionTypes.LicenceAccountRelatedContacts.UPDATE.SINGLE]({
        name,
        value,
        item,
        licence_account: this.selectedStatementDetails.licence_account,
      });
    },

    onRelatedContactSelected: function () {},

    deleteTrack: function (payload) {
      this[ActionTypes.LicenceRelatedTracks.DELETE.SINGLE](payload);
    },
    onAddTrack: function () {
      this[ActionTypes.LicenceRelatedTracks.INSERT.SINGLE](payload);
    },
    onDialogCancelled: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
        },
      });
    },
    onIncomeAdded: function () {
      this[ActionTypes.LicenceIncome.INSERT.SINGLE]({
        statement_id: this.statement_id,
      });
      this.onDialogCancelled();
    },
    onIncomeEdited: function () {
      this[ActionTypes.LicenceIncome.UPDATE.SINGLE]({
        statement_id: this.statement_id,
      });
      this.onDialogCancelled();
    },

    onDeleteImportMatch: function (payload) {
      this[ActionTypes.DistributionImportMatch.DELETE.SINGLE]({
        item: payload,
        statement_id: this.statement_id,
      });
    },

    onImportMatchChange: async function (payload) {
      await this[ActionTypes.DistributionImportMatch.SET.ALL]({
        ...payload,
        currentChannel: this.currentChannel,
      });
      await this.onDialogCancelled();
      //await this[ActionTypes.DistributionStatementsDetails.FETCH.SINGLE]({flag:true , reload:true ,statement:this.selectedStatementDetails.statement});
    },

    onImportSetupChange: function (payload) {
      this[ActionTypes.DistributionStatementImportSetup.UPDATE.SINGLE]({
        ...payload,
        statement_id: this.statement_id,
      });
    },

    onUpdateCostIncomedetails: function (payload) {
      this[ActionTypes.DistributionStatementSalesDetails.UPDATE.SINGLE]({
        ...payload,
        statement_id: this.statement_id,
      });
    },

    onDeleteSalesDetails: function (payload) {
      this[ActionTypes.DistributionStatementSalesDetails.DELETE.SINGLE](
        payload
      );
    },

    onUploadClick: function () {
      document.querySelector("#filepicker").click();
    },

    onFilePickerChange: async function (event) {
      //this.$router.push()

      console.log({ onFilePickerChange: 1 });
      const files = event.target.files;
      if (files.length > 0) {
        this.file = files[0];
      }
      console.log({
        statement_setting: this.statement_setting,
        file: this.file,
      });

      const formData = new FormData();
      formData.append("section", "statementsin");
      formData.append("action", "upload_statement");
      formData.append("statement_id", this.statement_id);
      formData.append("file_name_str", this.file?.name);
      formData.append("file_name", this.file);

      const file_types_pattern = /\.(xls|xlsx|csv|txt|tab|tsv)$/i; ///\.Add file extesion

      const matches = String(this.file?.name || "").match(file_types_pattern);
      if (!matches) {
        const confirmation = await ConfirmationService.createP({
          body: this.$t("Only xls ,xlsx ,csv ,txt ,tab ,tsv file is allowed"),
          results: [
            createConfirmResult({
              value: "ok",
              text: "OK",
              classes: ["v1 s7"],
            }),
          ],
        });

        return;
      }

      this.$router.push({
        ...this.$route,
        query: {
          modal: "progress_bar_modal",
        },
      });

      formData.append("file_type", matches[1]);
      this.fileUploadingFlag = true;

      await wait(5);
      this.fileUploaderProgress = 10;

      await wait(5);

      this.fileUploaderProgress = 30;
      await wait(5);

      this.fileUploaderProgress = 80;

      const res = await DistributionStatementService.uploadStatement(formData);

      this.fileUploaderDuration = 600;
      await wait(5);
      console.log(this.file, "::::::::::", res);
      await this[ActionTypes.DistributionStatementFile.INSERT.MULTIPLE]({
        file: res.data.file,
        statement_id: this.statement_id,
      });

      this.fileUploaderProgress = 100;

      await wait(600);

      this.onDialogCancelled();
    },

    onImportMatchScroll: function (value) {
      this[ActionTypes.DistributionImportMatch.INSERT.MULTIPLE]({
        statement_id: this.statement_id,
        start: value,
      });
    },

    onUpdateCostGroup: function (payload) {
      this[ActionTypes.DistributionStatementImportResultTotal.UPDATE.SINGLE]({
        statement_id: this.statement_id,
        ...payload,
      });
    },

    onProcessGroup: async function (payload) {
      await DistributionStatementService.updateStmtCostgroups(
        this.statement_id,
        payload
      );
      this[ActionTypes.DistributionStatementsDetails.FETCH.SINGLE]({
        statement: this.selectedStatementDetails.statement,
        reload: true,
      });
    },

    fetchUnmatchedLineInfo: async function () {
      const unmatchRes =
        await DistributionStatementService.display_statement_unmatched_lines_warning(
          this.statement_id
        );
      const display_statement_unmatched_lines_warning =
        unmatchRes.data.message_display;
      console.log({'statement-sidewindow.vue:1690 display_statement_unmatched_lines_warning' : display_statement_unmatched_lines_warning});

      if (display_statement_unmatched_lines_warning) {
        console.log(this.$t("unmatched_lines_warning"));
        okMessage(
          this.$t("unmatched_lines_warning"),
          this.$t("statement_not_ready")
        );
      }

      return display_statement_unmatched_lines_warning;
    },

    //import Result button method start
    onImportResultButtonClick: async function (menu) {
      console.log("MMMMMMMMM", menu);
      switch (menu) {
        case "invoice_statement": {
          const isUnmatched = await this.fetchUnmatchedLineInfo();
          console.log({'statement-sidewindow.vue:1709 isUnmatched' : isUnmatched});
          if (!isUnmatched) {
            this.onInvoiceStatementClick();
          }
          break;
        }
        case "refresh": {
          this[
            ActionTypes.DistributionStatementImportResultTotal.UPDATE.MULTIPLE
          ]({ ...this.selectedStatementDetails.statement });
          break;
        }
        case "ppu_fix_amount_btn": {
          this.$router.push({
            ...this.$route,
            query: {
              modal: "calculate_ppu_modal",
              statement_id:
                this.selectedStatementDetails.statement.statement_id,
            },
          });
          break;
        }
        case "open_related_invoice": {
          if (
            this.currentChannel == "costs" ||
            this.currentChannel == "income"
          ) {
            this.$router.push({
              name: costListLDTRoutes.names.tab,
              params: {
                invoice_id: this.invoice_id,
                tab: "overview",
              },
            });
          } 
          
          else {
            this.$router.push({
              name: invoiceListLDTRoutes.names.tab,
              params: {
                invoice_id: this.invoice_id,
                tab: "overview",
              },
            });
          }

          break;
        }
        case "price_export": {
          this.onPriceExportClick();
        }
        
      }
    },

    onPriceExportClick: function () {
      DistributionStatementService.physicalPriceExport(this.statement_id).then(
        (res) => {
          console.log(res, ":::::");
          FileDownload(res.data, "price_export.xlsx");
        }
      );
    },

    onInvoiceStatementClick: async function () {
      if (this.currentChannel == "costs" || this.currentChannel == "income") {
        const res = await DistributionStatementService.processCostsStatement(
          this.selectedStatementDetails.statement.statement_id
        );
        console.log(":::::::::", inv);
        const inv = res.data.invoice;

        this.$router.push({
          name: costListLDTRoutes.names.tab,
          params: {
            invoice_id: inv.invoice_id,
            tab: "overview",
          },
        });

        // this[ActionTypes.DistributionStatementsDetails.FETCH.SINGLE]({ statement:this.selectedStatementDetails.statement, reload:true} )
      } else {
        const { account_id } = this.selectedStatementDetails.statement;
        console.log(
          account_id,
          ":::::::::::::::",
          this.currentChannel,
          ":::::::::::::::",
          distributionAccountListLDTRoutes
        );
        this.$router.push({
          name: distributionAccountListLDTRoutes.names.tab,
          params: {
            account_id: account_id,
            tab: "current_statements",
          },
          query: {
            select_statement_id: this.statement_id,
          },
        });
      }
    },
    onClose: function () {
      const module = this.$store.getters.appNavItems.find(
        (e) => e.title == "Distribution"
      );
      console.log(module);
      const submodule = module.children.find(
        (e) => e.route == "statement_list"
      );

      const details = submodule.children.find(
        (e) => e.route == this.statement_id
      );
      handleCloseTab(this.$store, module, submodule, details);
    },

    onLoadPreset: async function (payload) {
      const { statement_id, statement_preset_id } = payload;
      await DistributionStatementService.setPreset(
        statement_id,
        statement_preset_id
      );
      this[ActionTypes.SET_SELECTED_COLUMNS]({
        ...payload,
        selected_columns: this.selectedStatementDetails.selected_columns,
      });
    },

    //import Result button method end
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-distribution-statment-sidewindow {
  .dt-grid-layout {
    height: calc(100vh - 119px);
  }
}
</style>


